// LYT Communications - Configuration Constants

export const colors = {
  blue: '#0077B6',
  teal: '#00B4D8',
  green: '#39B54A',
  darkBlue: '#023E8A',
  dark: '#0a1628',
  darkLight: '#0d1b2a',
  coral: '#e85a4f',
  orange: '#ff6b35',
  white: '#ffffff',
  gray: '#6b7280',
  grayLight: '#9ca3af',
  grayDark: '#374151',
};

export const LYT_INFO = {
  name: 'LYT Communications',
  address: '12130 State Highway 3',
  city: 'Webster',
  state: 'TX',
  zip: '77598',
  phone: '(832) 850-3887',
  email: 'info@lytcomm.com',
  adminEmails: ['matt@lytcomm.com', 'mason@lytcomm.com', 'donnie@lytcomm.com'],
};

export const URLS = {
  // ONBOARDING Script (v3.0) - Handles employee/contractor form submissions + email notifications + e-signing
  appsScript: 'https://script.google.com/macros/s/AKfycbwuBfWDZegdtnFloF_CehxiVI129RlEL9DEEt108r9HLYJopAMDvFYvmmOvhz4_rcGRQQ/exec',
  
  // PORTAL Script (v1.0) - Handles login, user management, password reset
  // Script ID: 1q7rGi07EhRasc5EdwU7QKGz7h_2-e1Qokk-EbVMEUHhz_IveC09sfcKG
  // DEPLOY FROM: https://script.google.com/d/1q7rGi07EhRasc5EdwU7QKGz7h_2-e1Qokk-EbVMEUHhz_IveC09sfcKG/edit
  // After deploying, update this URL:
  portalScript: 'https://script.google.com/macros/s/AKfycbyUHklFqQCDIFzHKVq488fYtAIW1lChNnWV2FWHnvGEr7Eq0oREhDE5CueoBJ6k-xhKOg/exec',
  
  googleDriveFolder: '11EuU2K-DzaT9KrDdbKOI4Q21c0-jKtiC',
  rateCardSheet: '10Py5x0vIUWPzKn1ZeTaIGyaEJonbz-0BHmSYV-20rB4',
  w4Pdf: '/Form%20W-4%20sign.pdf',
  w9Pdf: '/Form%20W-9%20sign.pdf',
  msaPdf: '/LYT_MSA_2026_AdobeSign_Full_v4_1.pdf',
};

// Onboarding invite code (general — shows employee/contractor choice)
export const INVITE_CODE = 'welcome2lyt';

// NDA signing invite code
export const NDA_INVITE_CODE = 'lytnda2026';

// Bastrop rate card access code (view-only, no onboarding)
export const BASTROP_RATE_CODE = 'bastroprates';

// ── Dynamic Onboarding Code Registry ──
// Each code maps to a project-specific onboarding config.
// Workers entering a project code skip the employee/contractor choice and go
// straight to contractor (1099) onboarding with project-specific rate card.
export const ONBOARDING_CODES = {
  'dfwhelper': {
    client: 'IE Smart Systems',
    project: 'DFW Airport Fiber',
    role: 'General Labor / Helper',
    description: 'DFW Airport fiber optic installation — General Labor',
    workerType: 'contractor',
    rateCardSheet: null,
    rates: [
      { code: 'DFW-HELP', description: 'General Labor / Helper', uom: 'HR', price: '$15.00', category: 'HOURLY RATES' },
    ],
    paymentTerms: 'Weekly',
    requireInsurance: false,
    requireFleet: false,
    requireVehicle: true,
    skipSteps: ['insurance', 'fleet'],
  },
  'dfwtech': {
    client: 'IE Smart Systems',
    project: 'DFW Airport Fiber',
    role: 'Fiber Technician',
    description: 'DFW Airport fiber optic installation — Fiber Technician',
    workerType: 'contractor',
    rateCardSheet: null,
    rates: [
      { code: 'DFW-TECH', description: 'Fiber Technician', uom: 'HR', price: '$25.00', category: 'HOURLY RATES' },
    ],
    paymentTerms: 'Weekly',
    requireInsurance: false,
    requireFleet: false,
    requireVehicle: true,
    skipSteps: ['insurance', 'fleet'],
  },
  'dfwlead': {
    client: 'IE Smart Systems',
    project: 'DFW Airport Fiber',
    role: 'Lead Technician',
    description: 'DFW Airport fiber optic installation — Lead Technician',
    workerType: 'contractor',
    rateCardSheet: null,
    rates: [
      { code: 'DFW-LEAD', description: 'Lead Technician', uom: 'HR', price: '$35.00', category: 'HOURLY RATES' },
    ],
    paymentTerms: 'Weekly',
    requireInsurance: false,
    requireFleet: false,
    requireVehicle: true,
    skipSteps: ['insurance', 'fleet'],
  },
  'bastrophelper': {
    client: 'Aspen Utility Company',
    project: 'Bastrop Fiber — Smithville Pulling',
    role: 'Pull Helper',
    description: 'Bastrop fiber pulling operations — Helper',
    workerType: 'contractor',
    rateCardSheet: null,
    rates: [
      { code: 'BST-HELP', description: 'Pull Helper', uom: 'HR', price: '$18.00', category: 'HOURLY RATES' },
    ],
    paymentTerms: 'Weekly',
    requireInsurance: false,
    requireFleet: false,
    requireVehicle: false,
    skipSteps: ['insurance', 'fleet'],
  },
  'bastroppuller': {
    client: 'Aspen Utility Company',
    project: 'Bastrop Fiber — Smithville Pulling',
    role: 'Experienced Puller',
    description: 'Bastrop fiber pulling operations — Experienced Puller',
    workerType: 'contractor',
    rateCardSheet: null,
    rates: [
      { code: 'BST-PULL', description: 'Experienced Fiber Puller', uom: 'HR', price: '$28.00', category: 'HOURLY RATES' },
    ],
    paymentTerms: 'Weekly',
    requireInsurance: false,
    requireFleet: false,
    requireVehicle: false,
    skipSteps: ['insurance', 'fleet'],
  },
  'highline2026': {
    client: 'Highline',
    project: 'Highline Texas Build',
    description: 'Highline aerial & underground fiber construction',
    workerType: 'contractor',
    rateCardSheet: '10Py5x0vIUWPzKn1ZeTaIGyaEJonbz-0BHmSYV-20rB4',  // existing sheet
    rates: null,  // fetched from sheet
    paymentTerms: 'Net 30',
    requireInsurance: true,
    requireFleet: true,
    skipSteps: [],
  },
  'vexus2026': {
    client: 'Vexus Fiber',
    project: 'Vexus LA/TX Build',
    description: 'Vexus Fiber underground & aerial construction',
    workerType: 'contractor',
    rateCardSheet: '10Py5x0vIUWPzKn1ZeTaIGyaEJonbz-0BHmSYV-20rB4',  // same sheet for now
    rates: null,
    paymentTerms: 'Net 7',
    requireInsurance: true,
    requireFleet: true,
    skipSteps: [],
  },
  'bastrop2026': {
    client: 'Aspen Utility Company',
    project: 'Highline Bastrop Fiber Build',
    description: 'Highline Bastrop underground, aerial, and splicing fiber construction',
    workerType: 'contractor',
    onboardingType: 'contractor',
    rateCardSheet: null,
    rates: [
      // ── UNDERGROUND ──
      { code: 'HL-UG02', description: 'Composite UG Conduit Placement - up to 2" conduit (incl. conduit, tracer wire, potholing)', uom: 'LF', price: '$4.88', category: 'UNDERGROUND' },
      { code: 'HL-UG04', description: 'Composite UG Conduit Placement - up to 4" hole (incl. up to 3x 1.25" conduit, tracer wire, handholes, potholing)', uom: 'LF', price: '$5.25', category: 'UNDERGROUND' },
      { code: 'HL-UG06', description: 'Bore, up to 2" hole w/ tracer wire, Min 36" cover', uom: 'LF', price: '$4.25', category: 'UNDERGROUND' },
      { code: 'HL-UG08', description: 'Bore, up to 2" hole w/ tracer wire, Min 48" cover', uom: 'LF', price: '$4.37', category: 'UNDERGROUND' },
      { code: 'HL-UG10', description: 'Bore, up to 3x2" w/ tracer wire, Min 36" cover', uom: 'LF', price: '$5.63', category: 'UNDERGROUND' },
      { code: 'HL-UG12', description: 'Bore, up to 3x2" w/ tracer wire, Min 48" cover', uom: 'LF', price: '$6.00', category: 'UNDERGROUND' },
      { code: 'HL-UG14', description: 'Bore, up to 4" hole w/ tracer wire, Min 36" cover', uom: 'LF', price: '$6.38', category: 'UNDERGROUND' },
      { code: 'HL-UG16', description: 'Bore, up to 4" hole w/ tracer wire, Min 48" cover', uom: 'LF', price: '$6.56', category: 'UNDERGROUND' },
      { code: 'HL-UG18', description: 'Bore, pull additional conduit adder up to 2", Min 36" cover', uom: 'LF', price: '$0.45', category: 'UNDERGROUND' },
      { code: 'HL-UG20', description: 'Bore, pull additional conduit adder up to 2", Min 48" cover', uom: 'LF', price: '$0.56', category: 'UNDERGROUND' },
      { code: 'HL-UG22', description: 'Bore, pull additional conduit adder up to 4", Min 36" cover', uom: 'LF', price: '$0.75', category: 'UNDERGROUND' },
      { code: 'HL-UG24', description: 'Bore, pull additional conduit adder up to 4", Min 48" cover', uom: 'LF', price: '$0.94', category: 'UNDERGROUND' },
      { code: 'HL-UG26', description: 'Bore, Soft rock/cobble adder (written approval), Min 36" cover', uom: 'LF', price: '$9.75', category: 'UNDERGROUND' },
      { code: 'HL-UG28', description: 'Bore, Soft rock/cobble adder (written approval), Min 48" cover', uom: 'LF', price: '$12.75', category: 'UNDERGROUND' },
      { code: 'HL-UG30', description: 'Bore, Solid rock/cobble adder (written approval), Min 36" cover', uom: 'LF', price: '$21.00', category: 'UNDERGROUND' },
      { code: 'HL-UG32', description: 'Bore, Solid rock/cobble adder (written approval), Min 48" cover', uom: 'LF', price: '$22.50', category: 'UNDERGROUND' },
      { code: 'HL-UG34', description: 'Plow, Min 36" Depth, one Duct, incl. 2 pre-rips if required', uom: 'LF', price: '$1.69', category: 'UNDERGROUND' },
      { code: 'HL-UG36', description: 'Plow, Min 48" Depth, one Duct, incl. 2 pre-rips if required', uom: 'LF', price: '$2.25', category: 'UNDERGROUND' },
      { code: 'HL-UG38', description: 'Pre-rip, after 2 rips - Pre-negotiated', uom: 'LF', price: '$0.45', category: 'UNDERGROUND' },
      { code: 'HL-UG40', description: 'Plow, Min 36" Depth, 2nd Duct Adder', uom: 'LF', price: '$0.15', category: 'UNDERGROUND' },
      { code: 'HL-UG42', description: 'Plow, Min 48" Depth, 2nd Duct Adder', uom: 'LF', price: '$0.26', category: 'UNDERGROUND' },
      { code: 'HL-UG44', description: 'Plow, Min 12" Depth, Direct Bury Cable or Micro duct for Drop', uom: 'LF', price: '$0.75', category: 'UNDERGROUND' },
      { code: 'HL-UG46', description: 'Open Trench, 4" wide chain cut; up to 3" duct, Pad & Backfill, Min 36" cover', uom: 'LF', price: '$3.19', category: 'UNDERGROUND' },
      { code: 'HL-UG48', description: 'Open Trench, 4" wide chain cut; up to 3" duct, Pad & Backfill, Min 48" cover', uom: 'LF', price: '$3.38', category: 'UNDERGROUND' },
      { code: 'HL-UG50', description: 'Open Trench, Mini Excavator; up to 3" duct, Pad & Backfill, Min 36" cover', uom: 'LF', price: '$3.19', category: 'UNDERGROUND' },
      { code: 'HL-UG52', description: 'Open Trench, Mini Excavator; up to 3" duct, Pad & Backfill, Min 48" cover', uom: 'LF', price: '$3.75', category: 'UNDERGROUND' },
      { code: 'HL-UG58', description: 'Rock Saw, 2" Wide, Min 24" cover', uom: 'LF', price: '$30.00', category: 'UNDERGROUND' },
      { code: 'HL-UG60', description: 'Rock Saw, 4" Wide, Min 24" cover', uom: 'LF', price: '$31.50', category: 'UNDERGROUND' },
      { code: 'HL-UG62', description: 'Joint Trench, Trench already open, up to two 2" ducts, Min 36" cover', uom: 'LF', price: '$0.75', category: 'UNDERGROUND' },
      { code: 'HL-UG64', description: 'Joint Trench, Trench already open, up to two 2" ducts, Min 48" cover', uom: 'LF', price: '$0.75', category: 'UNDERGROUND' },
      { code: 'HL-UG66', description: 'Micro-trench, 3/4" wide x 4"-6" Deep - 1 to 3 micro ducts and reinstatement', uom: 'LF', price: '$5.24', category: 'UNDERGROUND' },
      { code: 'HL-UG68', description: 'Micro-trench, Diamond Blade for gravel roads 20" Depth', uom: 'LF', price: '$8.51', category: 'UNDERGROUND' },
      { code: 'HL-UG70', description: 'Hand dig trench up to 50\', up to 24"', uom: 'EA', price: '$240.00', category: 'UNDERGROUND' },
      { code: 'HL-UG72', description: 'Duct rod/locate/rope existing duct', uom: 'LF', price: '$0.49', category: 'UNDERGROUND' },
      { code: 'HL-UG74', description: 'Place cable in conduit, up to 288 fiber (blow or pull)', uom: 'SF', price: '$0.49', category: 'UNDERGROUND' },
      { code: 'HL-UG76', description: 'Place additional cable in conduit, up to 288 fiber, adder (blow or pull)', uom: 'SF', price: '$0.30', category: 'UNDERGROUND' },
      { code: 'HL-UG78', description: 'Install 144F micro FDH combo pedestal/handhole w/ 12-port cassettes', uom: 'EA', price: '$131.25', category: 'UNDERGROUND' },
      { code: 'HL-UG80', description: 'Install Vault, 30x48x36 concrete, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$150.00', category: 'UNDERGROUND' },
      { code: 'HL-UG82', description: 'Install Vault, 24x36x24 concrete, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$123.75', category: 'UNDERGROUND' },
      { code: 'HL-UG84', description: 'Install Vault, 17x30x24 concrete, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$112.50', category: 'UNDERGROUND' },
      { code: 'HL-UG86', description: 'Install Vault, 13x24x18 concrete, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$86.25', category: 'UNDERGROUND' },
      { code: 'HL-UG88', description: 'Install Handhole, 30x48x36 hdpe, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$96.00', category: 'UNDERGROUND' },
      { code: 'HL-UG90', description: 'Install Handhole, 24x36x30 hdpe, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$75.00', category: 'UNDERGROUND' },
      { code: 'HL-UG92', description: 'Install Handhole, 17x30x15 hdpe, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$60.00', category: 'UNDERGROUND' },
      { code: 'HL-UG94', description: 'Install Handhole, 10x16x12 hdpe JD2001 SB Style, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$20.25', category: 'UNDERGROUND' },
      { code: 'HL-UG96', description: 'Install Handhole, 10x15x12 hdpe JD2000 SB Style, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$20.25', category: 'UNDERGROUND' },
      { code: 'HL-UG98', description: 'Install BDO(SPH14320) Dog house Style Pedestal, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$93.75', category: 'UNDERGROUND' },
      { code: 'HL-UG100', description: 'Install small 6-8 inch sprinkler valve box or Toby Box for ABF', uom: 'EA', price: '$12.75', category: 'UNDERGROUND' },
      { code: 'HL-UG102', description: 'Install Handhole, 12x15x12 (flowerpot style), incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$16.13', category: 'UNDERGROUND' },
      { code: 'HL-UG104', description: 'Install Handhole, 10" Round JD1000 Flowerpot Style, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$12.00', category: 'UNDERGROUND' },
      { code: 'HL-UG106', description: 'Install Round Marker, hdpe, including bonding', uom: 'EA', price: '$5.25', category: 'UNDERGROUND' },
      { code: 'HL-UG108', description: 'Install Flat Marker Stake, fiberglass', uom: 'EA', price: '$5.25', category: 'UNDERGROUND' },
      { code: 'HL-UG110', description: 'Install Round Marker Post with locate wire to vault', uom: 'EA', price: '$5.81', category: 'UNDERGROUND' },
      { code: 'HL-UG112', description: 'Install Pedestal, 8" round or square, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$15.00', category: 'UNDERGROUND' },
      { code: 'HL-UG114', description: 'Install Pedestal, 10" round or square, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$22.50', category: 'UNDERGROUND' },
      { code: 'HL-UG116', description: 'Install Pedestal, 12" round or square, incl. pea gravel, ground rod, duct caps', uom: 'EA', price: '$24.00', category: 'UNDERGROUND' },
      { code: 'HL-UG118', description: 'Dig and swing existing cable and set new 24x36x24 vault', uom: 'EA', price: '$176.25', category: 'UNDERGROUND' },
      { code: 'HL-UG120', description: 'Dig and swing existing cable and set new 17x30x24 vault', uom: 'EA', price: '$135.00', category: 'UNDERGROUND' },
      { code: 'HL-UG122', description: 'Dig & Swing existing Fiber or Duct', uom: 'EA', price: '$67.50', category: 'UNDERGROUND' },
      // ── AERIAL ──
      { code: 'HL-TREE', description: 'Tree Trimming Labor (includes disposal or stacked if required)', uom: 'LF', price: '$0.56', category: 'AERIAL' },
      { code: 'HL-MRE02', description: 'Install new pole in right-of-way up to 45 ft Any Class', uom: 'EA', price: '$637.50', category: 'AERIAL' },
      { code: 'HL-MRE04', description: 'Install new pole in right-of-way up to 45 ft Any Class in Rock', uom: 'EA', price: '$750.00', category: 'AERIAL' },
      { code: 'HL-AE02', description: 'Composite Aerial Placement of Strand (incl. strand, overhead guy, down guys, anchors, bonding)', uom: 'LF', price: '$0.53', category: 'AERIAL' },
      { code: 'HL-AE03', description: 'Composite Aerial Placement of Strand and Fiber (incl. strand, hardware, up to two 288F cables, guys, anchors, bonding)', uom: 'LF', price: '$0.90', category: 'AERIAL' },
      { code: 'HL-AE04', description: 'Placement of 1/4" strand and associated pole hardware only', uom: 'LF', price: '$0.41', category: 'AERIAL' },
      { code: 'HL-AE06', description: 'Install/lash up to two fiber cables to existing strand', uom: 'SF', price: '$0.53', category: 'AERIAL' },
      { code: 'HL-AE08', description: 'Install/lash additional (3rd) cable, adder', uom: 'SF', price: '$0.15', category: 'AERIAL' },
      { code: 'HL-AE10', description: 'Install fiber on strand, rear easement adder (requires written pre-approval)', uom: 'SF', price: '$0.07', category: 'AERIAL' },
      { code: 'HL-AE12', description: 'Overlash fiber on existing cable or aerial Micro duct', uom: 'SF', price: '$0.45', category: 'AERIAL' },
      { code: 'HL-AE14', description: 'Overlash fiber on existing cable, rear easement adder', uom: 'SF', price: '$0.10', category: 'AERIAL' },
      { code: 'HL-AE16', description: 'Delash and relash fiber', uom: 'SF', price: '$0.41', category: 'AERIAL' },
      { code: 'HL-AE18', description: 'Raise/Lower Existing Attachment (simple)', uom: 'EA', price: '$45.00', category: 'AERIAL' },
      { code: 'HL-AE20', description: 'Raise/Lower Existing Attachment (complex)', uom: 'EA', price: '$67.50', category: 'AERIAL' },
      { code: 'HL-AE22', description: 'Removal of all existing strand, cables, pole hardware, equipment, down guys & anchors', uom: 'EA', price: '$0.45', category: 'AERIAL' },
      { code: 'HL-AE24', description: 'Top Pole', uom: 'EA', price: '$61.50', category: 'AERIAL' },
      { code: 'HL-AE26', description: 'Install Snow-shoes (2) and associated slack loop', uom: 'EA', price: '$45.00', category: 'AERIAL' },
      { code: 'HL-AE28', description: 'Install Screw Anchor', uom: 'EA', price: '$35.25', category: 'AERIAL' },
      { code: 'HL-AE30', description: 'Install Rock Anchor', uom: 'EA', price: '$85.50', category: 'AERIAL' },
      { code: 'HL-AE32', description: 'Install Down Guy with Guy Guard', uom: 'EA', price: '$10.50', category: 'AERIAL' },
      { code: 'HL-AE34', description: 'Install Riser Guard', uom: 'EA', price: '$15.00', category: 'AERIAL' },
      { code: 'HL-AE36', description: 'Relocate Existing pole attachment - Straight Inline', uom: 'EA', price: '$54.75', category: 'AERIAL' },
      { code: 'HL-AE38', description: 'Relocate Existing pole attachment - Single Dead-end', uom: 'EA', price: '$60.00', category: 'AERIAL' },
      { code: 'HL-AE40', description: 'Relocate Existing pole attachment - Double Dead-end', uom: 'EA', price: '$78.75', category: 'AERIAL' },
      { code: 'HL-AE42', description: 'Relocate Existing pole attachment - Down Guy', uom: 'EA', price: '$44.25', category: 'AERIAL' },
      // ── SPLICING ──
      { code: 'HL-SPL02', description: 'Fiber splicing, Single, incl. Power Meter Testing and OTDR trace per strand', uom: 'EA', price: '$11.25', category: 'SPLICING' },
      { code: 'HL-SPL04', description: 'Fiber splicing, 12F Ribbon, incl. Power Meter Testing and OTDR trace per strand', uom: 'EA', price: '$71.25', category: 'SPLICING' },
      { code: 'HL-SPL06', description: 'Fiber testing/OTDR trace per strand, not associated with splicing', uom: 'EA', price: '$2.25', category: 'SPLICING' },
      { code: 'HL-SPL08', description: 'Fiber splicing labor, other hourly', uom: 'EA', price: '$41.25', category: 'SPLICING' },
      { code: 'HL-SPL10', description: 'Prep and install fiber into splice closure, incl. all bonds', uom: 'EA', price: '$56.25', category: 'SPLICING' },
      { code: 'HL-SPYJU', description: 'Prep and install fiber in Fiber Access Terminal (CommScope OFDC or equiv.) Underground', uom: 'EA', price: '$78.00', category: 'SPLICING' },
      { code: 'HL-SPYJA', description: 'Prep and install fiber in Fiber Access Terminal (CommScope OFDC or equiv.) Aerial', uom: 'EA', price: '$82.50', category: 'SPLICING' },
      { code: 'HL-SPE02', description: 'Prep and install fiber into pedestal (up to 12x12), incl. all bonds', uom: 'EA', price: '$60.75', category: 'SPLICING' },
      { code: 'HL-SPE04', description: 'Install electronics and power up active cabinet, new service', uom: 'EA', price: '$120.00', category: 'SPLICING' },
      { code: 'HL-SPE06', description: 'Install/place passive splitter cabinet (288 to 576 fiber)', uom: 'EA', price: '$225.00', category: 'SPLICING' },
      // ── MISCELLANEOUS ──
      { code: 'HL-LAB2', description: 'Install Ground Rod with wire and clamp', uom: 'EA', price: '$6.00', category: 'MISCELLANEOUS' },
      { code: 'HL-LAB4', description: 'Install concrete pad and place large active cabinet', uom: 'EA', price: '$600.00', category: 'MISCELLANEOUS' },
      { code: 'HL-LAB6', description: 'Install concrete pad and place small/mini active cabinet', uom: 'EA', price: '$468.75', category: 'MISCELLANEOUS' },
      { code: 'HL-LAB8', description: 'Install concrete pad and place passive splitter cabinet', uom: 'EA', price: '$405.00', category: 'MISCELLANEOUS' },
      { code: 'HL-LAB10', description: 'Install H-frame for mini OLT', uom: 'EA', price: '$86.25', category: 'MISCELLANEOUS' },
      { code: 'HL-LAB12', description: 'Core Drill Building up to 4" Diameter', uom: 'EA', price: '$48.75', category: 'MISCELLANEOUS' },
      { code: 'HL-HS02', description: 'Cut, Remove & Replace Concrete', uom: 'SQFT', price: '$14.25', category: 'MISCELLANEOUS' },
      { code: 'HL-HS04', description: 'Cut, Remove & Replace Asphalt', uom: 'SQFT', price: '$12.75', category: 'MISCELLANEOUS' },
      { code: 'HL-EM', description: 'Emergency Mobilization (per event)', uom: 'EA', price: '$262.50', category: 'MISCELLANEOUS' },
    ],
    paymentTerms: 'Net 30',
    retainageTerms: 'Retainage will be held for the extent of the customer\'s warranty period and will be released once expired.',
    requireInsurance: true,
    requireFleet: true,
    skipSteps: [],
  },
  'stc2026': {
    client: 'Southern Tele Communications',
    project: 'STC Maintenance & BAU',
    description: 'Southern Tele Communications — Fiber maintenance, splicing, and on-call/BAU work',
    workerType: 'contractor',
    onboardingType: 'contractor',
    rateCardSheet: null,
    rates: [
      // ── FIBER SPLICING ──
      { code: 'STC-SPL01', description: '1 - 24 fiber count', uom: 'EA', price: '$15.00', category: 'FIBER SPLICING' },
      { code: 'STC-SPL02', description: '25 - 144 fiber count', uom: 'EA', price: '$12.00', category: 'FIBER SPLICING' },
      { code: 'STC-SPL03', description: '145 - up fiber count', uom: 'EA', price: '$9.00', category: 'FIBER SPLICING' },
      { code: 'STC-SPL04', description: 'Closure, Fiber Splice (New)', uom: 'EA', price: '$150.00', category: 'FIBER SPLICING' },
      { code: 'STC-SPL05', description: 'Re-Enter Existing Enclosure up to 432 CT fiber', uom: 'EA', price: '$112.50', category: 'FIBER SPLICING' },
      { code: 'STC-SPL06', description: 'Re-Enter Existing Enclosure greater than 432 CT fiber', uom: 'EA', price: '$213.75', category: 'FIBER SPLICING' },
      { code: 'STC-SPL07', description: 'Installation / Prep FDP 1 - 24 (no hourly cost)', uom: 'EA', price: '$78.75', category: 'FIBER SPLICING' },
      { code: 'STC-SPL08', description: 'Installation / Prep FDP 25 - 144 (no hourly cost)', uom: 'EA', price: '$131.25', category: 'FIBER SPLICING' },
      { code: 'STC-SPL09', description: 'Installation / Prep FDP 145 - up (no hourly cost)', uom: 'EA', price: '$206.25', category: 'FIBER SPLICING' },
      { code: 'STC-SPL10', description: 'Bi-directional OTDR Testing/Power meter. Provide Test Package per FBL standard. Furnish Red-Line and updated SLW\'s. New Circuit turn-up only. Up to 12 fibers — Above 12 Quote All', uom: 'EA', price: '$213.75', category: 'FIBER SPLICING' },
      // ── MOBILIZATION ──
      { code: 'STC-MOB01', description: 'Mobilization w/Traffic Control (planned project) - 150 miles or less', uom: 'EA', price: '$187.50', category: 'MOBILIZATION' },
      { code: 'STC-MOB02', description: 'Mobilization w/Traffic Control (planned project) - 151 - 250 miles', uom: 'EA', price: '$412.50', category: 'MOBILIZATION' },
      { code: 'STC-MOB03', description: 'Mobilization w/Traffic Control (planned project) >251', uom: 'EA', price: '$600.00', category: 'MOBILIZATION' },
      // ── LABOR RATES ──
      { code: 'STC-LAB01', description: 'Supervisor w/ Truck', uom: 'HR', price: '$33.75', category: 'LABOR RATES' },
      { code: 'STC-LAB02', description: 'Foreman w/Truck', uom: 'HR', price: '$27.00', category: 'LABOR RATES' },
      { code: 'STC-LAB03', description: 'Operator w/Truck', uom: 'HR', price: '$22.50', category: 'LABOR RATES' },
      { code: 'STC-LAB04', description: 'Laborer w/truck', uom: 'HR', price: '$18.00', category: 'LABOR RATES' },
      { code: 'STC-LAB05', description: 'Splicer w/Truck & Trailer', uom: 'HR', price: '$75.00', category: 'LABOR RATES' },
      { code: 'STC-LAB06', description: 'UG Crew (1 foreman, 1 Lineman, 2 laborers w/truck/equipment)', uom: 'HR', price: '$195.94', category: 'LABOR RATES' },
      { code: 'STC-LAB07', description: 'Mobilization w/Traffic Control', uom: 'HR', price: '$412.50', category: 'LABOR RATES' },
      { code: 'STC-LAB08', description: 'Aerial Crew (1 foreman, 1 Lineman, 2 laborers w/truck/equipment)', uom: 'HR', price: '$165.00', category: 'LABOR RATES' },
      // ── AFTER HOURS ──
      { code: 'STC-AH01', description: 'After Hours - Supervisor w/ Truck', uom: 'HR', price: '$48.94', category: 'AFTER HOURS' },
      { code: 'STC-AH02', description: 'After Hours - Foreman w/Truck', uom: 'HR', price: '$39.15', category: 'AFTER HOURS' },
      { code: 'STC-AH03', description: 'After Hours - Operator w/Truck', uom: 'HR', price: '$32.62', category: 'AFTER HOURS' },
      { code: 'STC-AH04', description: 'After Hours - Laborer w/truck', uom: 'HR', price: '$26.10', category: 'AFTER HOURS' },
      { code: 'STC-AH05', description: 'After Hours - Splicer w/Truck & Trailer', uom: 'HR', price: '$100.00', category: 'AFTER HOURS' },
      { code: 'STC-AH06', description: 'After Hours - UG Crew (1 foreman, 1 Lineman, 2 laborers w/truck/equipment)', uom: 'HR', price: '$281.25', category: 'AFTER HOURS' },
      { code: 'STC-AH07', description: 'After Hours - Mobilization w/Traffic Control', uom: 'HR', price: '$598.12', category: 'AFTER HOURS' },
      { code: 'STC-AH08', description: 'After Hours - Aerial Crew (1 foreman, 1 Lineman, 2 laborers w/truck/equipment)', uom: 'HR', price: '$239.25', category: 'AFTER HOURS' },
    ],
    paymentTerms: 'Net 14',
    requireInsurance: true,
    requireFleet: true,
    skipSteps: [],
  },
  'lytnew': {
    client: 'LYT Communications',
    project: 'General In-House Work',
    role: 'General Worker',
    description: 'LYT Communications — General in-house worker',
    rates: [],
    allowRateInput: true,
    requireApproval: true,
    paymentTerms: 'Weekly',
    requireInsurance: false,
    requireFleet: false,
    requireVehicle: false,
  },
};

// Helper to look up an onboarding code (case-insensitive)
export function getOnboardingConfig(code) {
  if (!code) return null;
  return ONBOARDING_CODES[code.toLowerCase().trim()] || null;
}

// ── NDA-Gated Rate Card Codes ──
// Each key is a shareable invite code. Value references an ONBOARDING_CODES key to pull rates/project info from.
export const NDA_RATE_CODES = {
  'bastropnda': 'bastrop2026',
};

// Helper to look up NDA rate code → onboarding config
export function getNdaRateConfig(code) {
  if (!code) return null;
  const key = NDA_RATE_CODES[code.toLowerCase().trim()];
  return key ? ONBOARDING_CODES[key] : null;
}

// Admin configuration
export const ADMIN_CONFIG = {
  primaryAdmin: 'matt@lytcomm.com',
  notificationEmails: ['matt@lytcomm.com'],
  allowSecondaryAdmins: true,
};

// Client configurations (used for production submissions, invoices, and billing)
export const CLIENT_CONFIG = {
  'Vexus Fiber': {
    code: 'VXS',
    billingEmail: '',
    companyName: 'Vexus Fiber',
    paymentTerms: 'Net 7',
    rateCard: 'vexus-la-tx-2026',
  },
  'Highline': {
    code: 'HLN',
    billingEmail: '',
    companyName: 'Highline',
    paymentTerms: 'Net 30',
    rateCard: 'highline-tx-2026',
  },
  'IE Smart Systems': {
    code: 'IES',
    billingEmail: '',
    companyName: 'IE Smart Systems',
    paymentTerms: 'Net 30',
    rateCard: 'ies-dfw-2026',
  },
  'Aspen Utility Company': {
    code: 'ASP',
    billingEmail: '',
    companyName: 'Aspen Utility Company',
    paymentTerms: 'Net 30',
    rateCard: 'aspen-bastrop-2026',
  },
  'Southern Tele Communications': {
    code: 'STC',
    billingEmail: '',
    companyName: 'Southern Tele Communications',
    paymentTerms: 'Net 14',
    rateCard: 'stc-maint-2026',
  },
};

// Helper to get client config by name (case-insensitive partial match)
export function getClientConfig(clientName) {
  if (!clientName) return CLIENT_CONFIG['Vexus Fiber'];
  const key = Object.keys(CLIENT_CONFIG).find(k =>
    k.toLowerCase() === clientName.toLowerCase() ||
    clientName.toLowerCase().includes(k.toLowerCase())
  );
  return key ? CLIENT_CONFIG[key] : { code: 'OTH', billingEmail: '', companyName: clientName, paymentTerms: 'Net 30', rateCard: null };
}

export const images = {
  hero: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=1920&q=80',
  fiberClose: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=800&q=80',
  networkSwitch: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80',
  construction: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80',
  aerial: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=800&q=80',
  underground: 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?w=800&q=80',
  testing: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800&q=80',
  team: 'https://images.unsplash.com/photo-1531482615713-2afd69097998?w=800&q=80',
  hddDrill: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80',
  splicingTech: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800&q=80',
  bucketTruck: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=800&q=80',
};

export const services = [
  {
    id: 1,
    title: 'HDD Drilling',
    description: 'Horizontal Directional Drilling for underground fiber installation with minimal surface disruption.',
    image: images.underground,
  },
  {
    id: 2,
    title: 'Fiber Splicing',
    description: 'Precision fusion splicing and OTDR testing for optimal network performance.',
    image: images.fiberClose,
  },
  {
    id: 3,
    title: 'Aerial Construction',
    description: 'Pole-to-pole fiber installation, strand mapping, and aerial network builds.',
    image: images.aerial,
  },
  {
    id: 4,
    title: 'Underground Construction',
    description: 'Trenching, boring, and conduit installation for buried fiber networks.',
    image: images.construction,
  },
  {
    id: 5,
    title: 'Network Testing',
    description: 'Comprehensive OTDR, power meter, and certification testing services.',
    image: images.testing,
  },
  {
    id: 6,
    title: 'Project Management',
    description: 'End-to-end fiber project coordination from design to completion.',
    image: images.team,
  },
];

export const skillOptions = [
  'HDD Drilling',
  'Fiber Splicing',
  'Aerial Construction',
  'Underground Construction',
  'OTDR Testing',
  'Pole Climbing',
  'Bucket Truck Operation',
  'Project Management',
  'Safety Supervision',
  'Traffic Control',
];


// Gateway configuration (for portal components)
export const GATEWAY_CONFIG = {
  url: 'https://script.google.com/macros/s/AKfycbyFWHLgFOglJ75Y6AGnyme0P00OjFgE_-qrDN9m0spn4HCgcyBpjvMopsB1_l9MDjIctQ/exec',
  secret: 'LYTcomm2026ClaudeGatewaySecretKey99',
  usersSheetId: '1OjSak2YJJvbXjyX3FSND_GfaQUZ2IQkFiMRgLuNfqVw'
};

// ── Street Sheet Configuration ──
export const STREET_SHEET_CONFIG = {
  activityTypes: ['Bore', 'Plow', 'Pull', 'Splice', 'Set Fixtures', 'Restoration', 'Other'],
  roles: ['Crew Lead', 'Bore Operator', 'Pull Operator', 'Laborer', 'Flagger', 'Spotter', 'Other'],
  distributionEmails: {
    to: ['bastropconstruction@theaspencompany.com', 'erica.pawelek@theaspencompany.com', 'Brian.Hill@theaspencompany.com'],
    cc: ['matt@lytcomm.com', 'dayna@lytcomm.com'],
  },
  defaultProject: 'BASTROP',
  projectCode: 'HLBSMI1977',
  county: 'Bastrop',
  deadlineHour: 19, // 7 PM
};

// ── Utility Hit Tracker Configuration ──
export const UTILITY_HIT_CONFIG = {
  severityLevels: [
    { value: 'minor', label: 'Minor', color: '#f59e0b', description: 'Small nick or scratch, no service interruption' },
    { value: 'moderate', label: 'Moderate', color: '#f97316', description: 'Visible damage, potential service impact' },
    { value: 'major', label: 'Major', color: '#ef4444', description: 'Line severed or significant damage, service outage' },
    { value: 'critical', label: 'Critical', color: '#dc2626', description: 'Gas leak, electrical hazard, or imminent danger' },
  ],
  utilityTypes: ['Gas', 'Electric', 'Water', 'Sewer', 'Telecom', 'Cable', 'Fiber', 'Storm Drain', 'Other'],
  markingOptions: ['Yes', 'No', 'Partially', 'Not Requested'],
  statusFlow: ['Reported', 'Under Review', 'Repair Scheduled', 'Repaired', 'Closed'],
  distributionEmails: {
    to: ['Bastropcoclaims@theaspencompany.com', 'Claims@theaspencompany.com'],
    cc: ['matt@lytcomm.com', 'dayna@lytcomm.com'],
  },
  emergencyChecklist: [
    'Area secured / workers clear of hazard',
    '811 / utility company called',
    'Supervisor notified (Matt or crew lead)',
    'If gas: evacuate area, no ignition sources',
  ],
};

// ── DFW Airport Fiber Project Configuration ──
export const DFW_PORTAL_CONFIG = {
  accessCode: 'dfwportal',
  projectId: 'DFW-AIRPORT',

  // Workers who should be auto-routed to DFW portal on login (non-admin only)
  workerEmails: [
    'mason@lytcomm.com',
    'tony@lytcomm.com',
    'donnie@lytcomm.com',
    'ryanalexmoore13@gmail.com',
    'ddljones64@gmail.com',
    'daniel.tweddell@gmail.com',
    'tarahardin21@gmail.com',
  ],
  project: 'DFW Airport Fiber Installation',
  client: 'IE Smart Systems',
  prime: 'CTS1',
  contractValue: 280000,
  scope: 'Interior fiber cabling across DFW airport terminals RS2, RS4, and Garage. Approximately 37,000 feet of cable pulling, 2,040 splices, cable tray installation, 300 J-hooks with stringers, 10 fire sleeves, termination, and OTDR testing.',

  // Milestones
  milestones: [
    { area: 'RS2', deadline: '2026-06-08', description: 'RS2 Terminal Complete' },
    { area: 'RS4', deadline: '2026-06-19', description: 'RS4 Terminal Complete' },
    { area: 'Garage', deadline: '2026-07-10', description: 'Garage Final Turnover' },
  ],

  // Work areas for daily report dropdown
  areas: ['RS2 Terminal', 'RS4 Terminal', 'Garage', 'Laydown Area', 'Other'],

  // Roles & pay rates
  roles: {
    helper: { title: 'General Labor / Helper', rate: 15.00, code: 'DFW-HELP' },
    tech:   { title: 'Fiber Technician',       rate: 25.00, code: 'DFW-TECH' },
    lead:   { title: 'Lead Technician',        rate: 35.00, code: 'DFW-LEAD' },
  },

  // Work type options for daily report
  workTypes: [
    'Cable Pulling', 'Splicing', 'Cable Tray Install', 'J-Hook / Stringer Install',
    'Termination', 'OTDR Testing', 'Fire Sleeve Install', 'Conduit Install',
    'Material Handling / Staging', 'Cleanup / Restoration', 'Lift Operation',
    'Training / Orientation', 'Safety Meeting / Toolbox Talk', 'Other',
  ],

  // Equipment options
  equipment: [
    'Mini20 Scissor Lift', 'Fusion Splicer', 'OTDR', 'Fiber Cleaver',
    'CO2 / Gas Tool (J-hooks)', 'Cable Puller', 'Hand Tools', 'Other',
  ],

  // Key contacts
  contacts: [
    { name: 'Matt Roy',        role: 'LYT On-Site Manager',  phone: '(281) 832-8058', email: 'matt@lytcomm.com' },
    { name: 'Dayna Roy',       role: 'LYT Operations',       phone: '(281) 389-7827', email: 'dayna@lytcomm.com' },
    { name: 'Mason Roy',       role: 'LYT Field Ops',        phone: '(832) 547-0140', email: 'mason@lytcomm.com' },
    { name: 'Carlos Escareno', role: 'IES Project Manager',  phone: '(281) 253-5892', email: 'cescareno@iesmartsystems.com' },
    { name: 'Barry Turner',    role: 'CTS1 Project Manager', phone: '(774) 556-4094', email: 'bturner@cts1.com' },
  ],

  // DFW-specific site rules — workers must acknowledge these
  siteRules: [
    { category: 'Schedule', rules: [
      'This is a NIGHT SHIFT project. All work is performed after terminal closure.',
      'Material laydown begins at 8:00 PM. AOA work begins at 10:00 PM after terminal closes.',
      'All work must be completed and areas restored before terminal reopens.',
    ]},
    { category: 'Airport Security & Badge', rules: [
      'Your airport badge must be worn and VISIBLE at ALL times while on the AOA (Airport Operations Area).',
      'Unbadged workers must be accompanied by an approved escort at ALL times — no exceptions.',
      'Non-Movement badge allows driving on the AOA secured area. Follow all airport driving rules.',
      'If your badge is lost, stolen, or damaged, report it IMMEDIATELY to your supervisor.',
      'Badges must be returned upon project completion or termination — failure to return may result in fines.',
    ]},
    { category: 'Scissor Lift & Equipment Safety', rules: [
      'All lifts are Mini20 single-man scissor lifts provided by CTS/Sunbelt.',
      'Spotters are required ONLY when moving lifts into the building and positioning them.',
      'Once a lift is set and you have your tools on board, no ground spotter is needed.',
      'Cones must be placed around the lift work area before raising the platform.',
      'Fall protection: Always use the platform guardrails. No leaning over or standing on rails.',
      'You must have a valid Scissor Lift Certification before operating any lift.',
    ]},
    { category: 'Safety & Incident Reporting', rules: [
      'Wear required PPE at all times: hard hat, safety glasses, hi-vis vest, steel-toe boots, gloves as needed.',
      'Report ALL accidents, injuries, near-misses, and property damage to your supervisor IMMEDIATELY.',
      'You have STOP WORK AUTHORITY — if conditions are unsafe, STOP and report.',
      'All tools must be checked in/out at the beginning and end of each shift.',
      'Safety violations may result in IMMEDIATE termination.',
    ]},
    { category: 'Pay & Employment', rules: [
      'You are engaged as an independent contractor (1099). You are responsible for all federal, state, and local taxes.',
      'LYT does NOT provide workers\' compensation, health insurance, or any employee benefits.',
      'Pay is weekly via direct deposit at your agreed hourly rate. No overtime premium, holiday pay, or shift differential unless expressly agreed in writing.',
      'You must submit accurate daily reports. LYT reserves the right to audit all time submissions.',
      'Falsifying time records is grounds for immediate termination.',
    ]},
    { category: 'Confidentiality', rules: [
      'Do not discuss project details, pricing, client information, or security protocols with anyone outside the project team.',
      'No photographs of airport security infrastructure, access points, or restricted areas.',
      'Carriers (AT&T, etc.) require confidentiality — this is a contractual obligation.',
    ]},
  ],

  // Compliance checklist items — badge process + certifications + docs
  complianceItems: [
    { id: 'badge_app',     label: 'Badge Application Submitted',  category: 'Airport Badge', order: 1 },
    { id: 'fingerprints',  label: 'Fingerprinted at DFW',         category: 'Airport Badge', order: 2 },
    { id: 'background',    label: 'Background Check Cleared',     category: 'Airport Badge', order: 3 },
    { id: 'badge_training',label: 'Airport Security Training Done',category: 'Airport Badge', order: 4 },
    { id: 'badge_issued',  label: 'Airport Badge Picked Up',      category: 'Airport Badge', order: 5 },
    { id: 'vehicle_aoa',   label: 'Vehicle AOA Pass Issued',      category: 'Airport Badge', order: 6 },
    { id: 'osha',          label: 'OSHA 10/30 Certification',     category: 'Certifications', order: 7 },
    { id: 'scissor_lift',  label: 'Scissor Lift Certification',   category: 'Certifications', order: 8 },
    { id: 'w9',            label: 'W-9 Signed',                   category: 'Documents', order: 9 },
    { id: 'ica',           label: 'Contractor Agreement Signed',  category: 'Documents', order: 10 },
    { id: 'rate_card',     label: 'Rate Card Accepted',           category: 'Documents', order: 11 },
    { id: 'direct_deposit',label: 'Direct Deposit Set Up',        category: 'Documents', order: 12 },
    { id: 'id_verified',   label: 'ID Verification Uploaded',     category: 'Documents', order: 13 },
    { id: 'safety_ack',    label: 'Safety Manual Acknowledged',   category: 'Documents', order: 14 },
    { id: 'site_rules',    label: 'DFW Site Rules Acknowledged',  category: 'Documents', order: 15 },
  ],
};
